import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=084ea316&"
import script from "./MessageView.vue?vue&type=script&lang=ts&"
export * from "./MessageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports